import { render, staticRenderFns } from "./PrintersView.vue?vue&type=template&id=454b695d&scoped=true&"
import script from "./PrintersView.vue?vue&type=script&lang=js&"
export * from "./PrintersView.vue?vue&type=script&lang=js&"
import style0 from "./PrintersView.vue?vue&type=style&index=0&id=454b695d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b695d",
  null
  
)

export default component.exports